export const UPDATE_NEW_REQUESTS_CURRENT_CACHE_KEY =
  'UPDATE_NEW_REQUESTS_CURRENT_CACHE_KEY';
export const GET_NEW_REQUESTS_API_REQUEST = 'GET_NEW_REQUESTS_API_REQUEST';
export const GET_NEW_REQUESTS_API_SUCCESS = 'GET_NEW_REQUESTS_API_SUCCESS';
export const GET_NEW_REQUESTS_API_ERROR = 'GET_NEW_REQUESTS_API_ERROR';
export const GET_NEXT_NEW_REQUESTS_SUCCESS = 'GET_NEXT_NEW_REQUESTS_SUCCESS';
